import { H3 } from '@/components/typography/heading/headings.component';
import { TableBody, TableBorderless, TableCell, TableHead, TableRow } from '@/components/ui/table';
import { cn } from '@/lib/utils';
import { ProjectBasicDetailsData } from '@/modules/Report/Report.schema';

export type Props = {
  data: ProjectBasicDetailsData;
  className?: string;
};

export const ProjectBasicInfoTable = ({ data, className }: Props) => {
  if (!data) return null;

  return (
    <div className={cn('gap-3', className)}>
      <H3>Project Level Information</H3>
      <div className={cn('flex flex-col')}>
        <TableBorderless>
          {/* General Info Section */}
          <TableBody>
            <TableRow>
              <TableHead className="w-1/2">Project Name</TableHead>
              <TableCell className="text-right">{data.projectName}</TableCell>
            </TableRow>
            <TableRow>
              <TableHead className="w-1/2">Project ID</TableHead>
              <TableCell className="text-right">{data.projectId}</TableCell>
            </TableRow>
            <TableRow>
              <TableHead className="w-1/2">Core Extraction Dates</TableHead>
              <TableCell className="text-right">{data.coreExtractionDates}</TableCell>
            </TableRow>
            <TableRow>
              <TableHead className="w-1/2">Sample Analysis Dates</TableHead>
              <TableCell className="text-right">{data.sampleAnalysisDates}</TableCell>
            </TableRow>
            <TableRow>
              <TableHead className="w-1/2">Major Soil Type</TableHead>
              <TableCell className="text-right">{data.majorSoilType}</TableCell>
            </TableRow>
            <TableRow>
              <TableHead className="w-1/2">Mean Soil Depth (mm)</TableHead>
              <TableCell className="text-right">{data.meanSoilDepthMm}</TableCell>
            </TableRow>
            <TableRow>
              <TableHead className="w-1/2">Total Project Area (ha)</TableHead>
              <TableCell className="text-right">{data.totalProjectAreaHa}</TableCell>
            </TableRow>
          </TableBody>
          {/* Section Divider */}
          <TableBody className="border-t border-secondary">
            <TableRow>
              <TableHead className="w-1/2">Number of Fields</TableHead>
              <TableCell className="text-right">{data.totalNumberOfFields}</TableCell>
            </TableRow>
            <TableRow>
              <TableHead className="w-1/2">Mean Field Area (ha)</TableHead>
              <TableCell className="text-right">{data.meanFieldAreaHa}</TableCell>
            </TableRow>
          </TableBody>
          {/* Section Divider */}
          <TableBody className="border-t border-secondary">
            <TableRow>
              <TableHead className="w-1/2">Core Count</TableHead>
              <TableCell className="text-right">{data.totalCores}</TableCell>
            </TableRow>
            <TableRow>
              <TableHead className="w-1/2">Cores per Hectare</TableHead>
              <TableCell className="text-right">{data.coresPerHectare}</TableCell>
            </TableRow>
          </TableBody>
          {/* Carbon Section - Gold border and highlight */}
          <TableBody className="border-l-8 border-secondary">
            <TableRow>
              <TableHead className="w-1/2">Total Carbon Stock (t)</TableHead>
              <TableCell className="text-right font-semibold">{data.totalCarbonStockTonnes}</TableCell>
            </TableRow>
            <TableRow>
              <TableHead className="w-1/2">Mean Carbon Stock (t/ha)</TableHead>
              <TableCell className="text-right font-semibold">{data.avgCarbonStockTpha}</TableCell>
            </TableRow>
            <TableRow>
              <TableHead className="w-1/2">Standard Deviation of Carbon Stock (t/ha)</TableHead>
              <TableCell className="text-right font-semibold">{data.stdDevCarbonStockTpha}</TableCell>
            </TableRow>
          </TableBody>
        </TableBorderless>
      </div>
    </div>
  );
};
